module.exports = __webpack_public_path__ + "static/media/kenya.eb73f3df.png";